webpackJsonp([19],{

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1035);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("2f32e253", content, true, {});

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, ".content_add[data-v-5d247036]{width:100%;margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.title[data-v-5d247036]{font-size:15px;padding-top:20px;margin-bottom:-20px}.btn_more[data-v-5d247036]{margin-top:1px;border-radius:5px}.btn_min[data-v-5d247036]{font-size:14px;margin-top:20%;margin-left:165px;cursor:pointer;position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/opt/build/repo/src/pages/template/page-template-edit-name.vue"],"names":[],"mappings":"AACA,8BACC,WAAY,AACZ,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAChC,AACD,wBACC,eAAgB,AAChB,iBAAkB,AAClB,mBAAqB,CACrB,AACD,2BACC,eAAgB,AAChB,iBAAmB,CACnB,AACD,0BACC,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC5B","file":"page-template-edit-name.vue","sourcesContent":["\n.content_add[data-v-5d247036]{\n\twidth: 100%;\n\tmargin-top: 20px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n.title[data-v-5d247036]{\n\tfont-size: 15px;\n\tpadding-top: 20px;\n\tmargin-bottom: -20px;\n}\n.btn_more[data-v-5d247036]{\n\tmargin-top: 1px;\n\tborder-radius: 5px;\n}\n.btn_min[data-v-5d247036]{\n\tfont-size: 14px;\n\tmargin-top: 20%;\n\tmargin-left: 165px;\n\tcursor: pointer;\n\tposition: relative;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Editar Template","value":_vm.value},on:{"close-modal":_vm.closeModal}},[_c('v-layout',{attrs:{"wrap":"","pa-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('label',[_vm._v("Nombre template\n\t\t\t\t\t"),_c('v-text-field',{staticClass:"body-1",attrs:{"solo":"","hide-details":"","label":"Nombre del template","required":"","error":_vm.$v.data.name.$error},model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('label',[_vm._v("Planes")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","multiple":"","box":"","chips":"","background-color":"white","hide-details":"","item-text":"name","item-value":"id","label":"Planes","items":_vm.plans,"return-object":""},model:{value:(_vm.model.plans),callback:function ($$v) {_vm.$set(_vm.model, "plans", $$v)},expression:"model.plans"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('label',[_vm._v("Integraciones Agregadas")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","multiple":"","box":"","chips":"","hide-details":"","disabled":true,"background-color":"white","item-text":"name","item-value":"id","label":"Integraciones Agregadas","items":_vm.integrations,"return-object":""},model:{value:(_vm.model.integrations),callback:function ($$v) {_vm.$set(_vm.model, "integrations", $$v)},expression:"model.integrations"}})],1),_vm._v(" "),_c('div',{staticClass:"content_add"},[_c('label',{staticClass:"title"},[_vm._v("Seleccione las integraciones con una categoría")])]),_vm._v(" "),_vm._l((_vm.contIntegrations),function(integration,index){return _c('v-layout',{key:index,attrs:{"wrap":"","pa-6s":""}},[_c('v-flex',{attrs:{"xs6":"","mt-5":""}},[_c('label',[_vm._v("Integraciones")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","multiple":"","box":"","chips":"","hide-details":"","background-color":"white","item-text":"name","item-value":"id","label":"Integraciones","items":_vm.integrationsList,"return-object":""},model:{value:(_vm.model.generalIntegrations[index]),callback:function ($$v) {_vm.$set(_vm.model.generalIntegrations, index, $$v)},expression:"model.generalIntegrations[index]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","mt-5":""}},[_c('label',[_vm._v("Categorías")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"solo":"","simple":"","box":"","chips":"","hide-details":"","background-color":"white","item-text":"name","item-value":"id","label":"Categorías","items":_vm.categories,"return-object":""},model:{value:(_vm.model.generalCategories[index]),callback:function ($$v) {_vm.$set(_vm.model.generalCategories, index, $$v)},expression:"model.generalCategories[index]"}})],1),_vm._v(" "),(_vm.showRemoveButton(index))?_c('v-flex',{attrs:{"xs1":"","mt-1":""}},[_c('v-btn',{staticClass:"btn_min",attrs:{"color":"error"},on:{"click":function($event){return _vm.removeIntegrationRow(index)}}},[_vm._v("Quitar Selectores\n\t\t\t\t\t")])],1):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"content_add"},[_c('v-btn',{staticClass:"btn_more",attrs:{"color":"primary","disabled":!_vm.hasSelections},on:{"click":_vm.addIntegrationRow}},[_vm._v("Seleccionar más integraciones\n\t\t\t\t")])],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.sendData,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_edit_name_vue__ = __webpack_require__(834);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d247036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_edit_name_vue__ = __webpack_require__(1036);
function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d247036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_edit_name_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d247036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_edit_name_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(566));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(565));

var _alphaNum = _interopRequireDefault(__webpack_require__(568));

var _numeric = _interopRequireDefault(__webpack_require__(569));

var _between = _interopRequireDefault(__webpack_require__(570));

var _email = _interopRequireDefault(__webpack_require__(571));

var _ipAddress = _interopRequireDefault(__webpack_require__(572));

var _macAddress = _interopRequireDefault(__webpack_require__(573));

var _maxLength = _interopRequireDefault(__webpack_require__(574));

var _minLength = _interopRequireDefault(__webpack_require__(575));

var _required = _interopRequireDefault(__webpack_require__(576));

var _requiredIf = _interopRequireDefault(__webpack_require__(577));

var _requiredUnless = _interopRequireDefault(__webpack_require__(578));

var _sameAs = _interopRequireDefault(__webpack_require__(579));

var _url = _interopRequireDefault(__webpack_require__(580));

var _or = _interopRequireDefault(__webpack_require__(581));

var _and = _interopRequireDefault(__webpack_require__(582));

var _not = _interopRequireDefault(__webpack_require__(583));

var _minValue = _interopRequireDefault(__webpack_require__(584));

var _maxValue = _interopRequireDefault(__webpack_require__(585));

var _integer = _interopRequireDefault(__webpack_require__(586));

var _decimal = _interopRequireDefault(__webpack_require__(587));

var helpers = _interopRequireWildcard(__webpack_require__(558));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'https://ec-motor.makipos.la',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"SALES_URL":'https://ec-sales.makipos.la',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://maki-acl.s3.amazonaws.com/ACL/fenix.png',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(567).withParams : __webpack_require__(165).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(167);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(164);




var loadPlans = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var url, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						url = 'plan/list';
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get(url);

					case 4:
						response = _context.sent;

						this.plans = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.data));
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 8]]);
	}));

	return function loadPlans() {
		return _ref.apply(this, arguments);
	};
}();

var editTemplate = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var headers, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context2.next = 3;
						return this.$http.get('template/' + this.id, { headers: headers });

					case 3:
						response = _context2.sent;

						this.data = response.data.data;
						this.model.plans = response.data.data.plans;
						this.model.integrations = response.data.data.integrations.integrations;

					case 7:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function editTemplate() {
		return _ref2.apply(this, arguments);
	};
}();

var sendData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _this = this;

		var headers, idsPlan, idsIntegration, body, response, url, selectedIntegrations, model;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						idsPlan = this.model.plans ? this.model.plans.map(function (plan) {
							return plan.id;
						}) : [];
						idsIntegration = this.model.integrations ? this.model.integrations.map(function (integration) {
							return integration.id;
						}) : [];
						body = {
							name: this.data.name,
							description: this.data.description,
							plans: idsPlan,
							integrations: idsIntegration
						};
						_context3.next = 6;
						return this.$http.put('template/' + this.id, body, { headers: headers });

					case 6:
						response = _context3.sent;
						url = 'integrations-template';
						selectedIntegrations = [];

						this.model.generalIntegrations.forEach(function (integrations, index) {
							integrations.forEach(function (integration) {
								var category = _this.model.generalCategories[index];
								selectedIntegrations.push({
									id: integration.id,
									code: integration.code,
									name: integration.name,
									price: '0',
									categoryId: category.id,
									flagStatus: false,
									flagDefault: true,
									categoryCode: category.code,
									categoryName: category.name
								});
							});
						});
						model = {
							integrations: selectedIntegrations,
							integrationIds: selectedIntegrations.map(function (integration) {
								return integration.id;
							}),
							templateCode: this.codeTemplate
						};
						_context3.next = 13;
						return this.$http.patch(url, model);

					case 13:
						this.data = response.data.data;
						this.showNotification('El template fue actualizado correctamente.');
						this.closeModal();

					case 16:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function sendData() {
		return _ref3.apply(this, arguments);
	};
}();

var loadIntegrations = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var headers, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.get('template/' + this.id, { headers: headers });

					case 4:
						response = _context4.sent;

						this.integrations = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.data.integrations.integrations));
						_context4.next = 11;
						break;

					case 8:
						_context4.prev = 8;
						_context4.t0 = _context4['catch'](1);

						this.showNotification('El template no tiene integraciones');

					case 11:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 8]]);
	}));

	return function loadIntegrations() {
		return _ref4.apply(this, arguments);
	};
}();

var allIntegrations = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var url, dataResponse;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.prev = 0;
						url = 'integrations';
						_context5.next = 4;
						return this.$http.get(url);

					case 4:
						dataResponse = _context5.sent;

						this.integrationsList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(dataResponse.data.data));
						_context5.next = 11;
						break;

					case 8:
						_context5.prev = 8;
						_context5.t0 = _context5['catch'](0);

						this.showError();

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[0, 8]]);
	}));

	return function allIntegrations() {
		return _ref5.apply(this, arguments);
	};
}();

var allCategories = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var url, catResponse;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.prev = 0;
						url = 'categories';
						_context6.next = 4;
						return this.$http.get(url);

					case 4:
						catResponse = _context6.sent;

						this.categories = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(catResponse.data.data));
						_context6.next = 11;
						break;

					case 8:
						_context6.prev = 8;
						_context6.t0 = _context6['catch'](0);

						this.showError();

					case 11:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[0, 8]]);
	}));

	return function allCategories() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.editTemplate();
	this.loadPlans();
	this.loadIntegrations();
	this.allIntegrations();
	this.allCategories();
}

function validations() {
	return {
		data: {
			name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
		}
	};
}

function closeModal() {
	this.loading = true;
	this.goTo('page-template', { params: { projectId: this.projectId } });
	this.loading = false;
}

function addIntegrationRow() {
	var newIndex = this.contIntegrations.length;
	this.$set(this.contIntegrations, newIndex, newIndex);
	this.$set(this.model.generalIntegrations, newIndex, []);
	this.$set(this.model.generalCategories, newIndex, []);
	this.showRemoveButtonFlags[newIndex] = true;
}

function removeIntegrationRow(index) {
	this.contIntegrations.splice(index, 1);
	this.model.generalIntegrations.splice(index, 1);
	this.model.generalCategories.splice(index, 1);
	this.showRemoveButtonFlags.splice(index, 1);
}

function showRemoveButton(index) {
	return this.showRemoveButtonFlags[index];
}

function data() {
	return {
		data: {},
		loading: false,
		value: true,
		add_integration: false,
		model: {
			name: '',
			plans: [],
			integrations: [],
			integrationsList: [],
			categories: [],
			generalIntegrations: [],
			generalCategories: []
		},
		plans: [],
		integrations: [],
		integrationsList: [],
		categories: [],
		contIntegrations: [0],
		showRemoveButtonFlags: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-template-edit-name',
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["default"]
	},
	computed: {
		hasSelections: function hasSelections() {
			return this.model.generalIntegrations.length !== 0 && this.model.generalCategories.length !== 0;
		}
	},
	data: data,
	methods: {
		closeModal: closeModal,
		editTemplate: editTemplate,
		sendData: sendData,
		loadPlans: loadPlans,
		loadIntegrations: loadIntegrations,
		allIntegrations: allIntegrations,
		allCategories: allCategories,
		addIntegrationRow: addIntegrationRow,
		removeIntegrationRow: removeIntegrationRow,
		showRemoveButton: showRemoveButton
	},
	props: {
		id: {
			type: [Number, String]
		},
		projectId: {
			type: [Number, String]
		},
		codeTemplate: {
			type: [Number, String]
		}
	},
	validations: validations
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.44b37456d6c66ac7f5b0.js